const VKONTACTE = {
  api: 'http://vk.com/share.php',
  mod: 'vk',
  title: 'ВКонтакте',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'description',
    image: 'image'
  }
};
const FACEBOOK = {
  api: 'http://www.facebook.com/sharer.php',
  mod: 'fb',
  title: 'Facebook',
  keys: {
    url: 'u',
  }
};
const ODNOKLASSNIKI = {
  api: 'https://connect.ok.ru/offer',
  mod: 'ok',
  title: 'Одноклассники',
  // additionalKey: 'st.cmd=addShare&st.s=1',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'st.comments',
    image: 'imageUrl',
  }
};
const TWITTER = {
  api: 'http://twitter.com/share',
  mod: 'tw',
  title: 'Twitter',
  keys: {
    url: 'url',
    title: 'text',
  }

};
const TELEGRAM = {
  api: 'https://telegram.me/share/url',
  mod: 'tg',
  title: 'Telegram',
  keys: {
    url: 'url',
    title: 'text',
  }
};
const WHATSAPP = {
  api: 'https://api.whatsapp.com/send',
  mod: 'wa',
  title: 'WhatsApp',
  keys: {
    messangerText: 'text',
  }
};
const VIBER = {
  api: 'viber://forward',
  mod: 'vb',
  title: 'Viber',
  keys: {
    messangerText: 'text',
  }
};

const SHARE_DEFAULT = [
  ['vk', VKONTACTE],
  ['fb', FACEBOOK],
  ['ok', ODNOKLASSNIKI],
  ['twitter', TWITTER],
  ['telegram', TELEGRAM],
  ['whatsapp', WHATSAPP],
  ['viber', VIBER]
];

const getUrl = function(itemSettings, parameters) {
  if (!itemSettings.api) {
    return null;
  }
  let isFirstKey = true;
  let url = itemSettings.api;
  if ('additionalKey' in itemSettings) {
    url += (isFirstKey) ? '?' : '&';
    url += itemSettings.additionalKey;
    isFirstKey = false;
  }
  Object.keys(itemSettings.keys).forEach((key) => {
    if (key in parameters) {
      url += (isFirstKey) ? '?' : '&';
      isFirstKey = false;
      url += ((key === 'title') && !('url' in itemSettings.keys)) ? `${itemSettings.keys[key]}=${encodeURIComponent(parameters[key] + ' ' + parameters['url'])}` : `${itemSettings.keys[key]}=${encodeURIComponent(parameters[key])}`;
    }
  });
  return url;
}

const createShareContainer = function (pageSettings = {
    url: 'https://www.womanhit.ru/spec-projects/podaroksamomystilnomu/',
    messangerText: 'https://www.womanhit.ru/spec-projects/podaroksamomystilnomu/',
    title: 'Подбери правильный подарок своему любимому'
  }, buttonSettings = SHARE_DEFAULT) {
  const root = document.createElement('ul');
  root.classList.add('share');

  buttonSettings.forEach((settings) => {
    const item = document.createElement('li');
    item.classList.add('share__item');
    item.classList.add(`share__item_${settings[1].mod}`);
    let url = getUrl(settings[1], pageSettings);
    item.innerHTML = `<a href="${url}" class="share__link" rel="nofollow noopener" aria-label="Поделиться через ${settings[1].title}"><svg class="share__icon" width="32" height="32"><use xlink:href="#icon-${settings[1].mod}"></use></svg></a>`;
    item.querySelector('.share__link').addEventListener('click', function(evt) {
      evt.preventDefault();
      window.open(url,'','toolbar=0,status=0,width=626,height=436');
    });

    root.appendChild(item);
  });
  return root;
}

export default createShareContainer;
